import igos, { VVSGOTCHI_IGO_ID, DEFAULT_IGO_SALE_DURATION } from 'config/constants/igos'

export const currentIgo = igos.find((igo) => igo.id === VVSGOTCHI_IGO_ID)
export const currentIgoStartTime = currentIgo ? new Date(currentIgo.saleDate) : null
export const currentIgoEndTime = currentIgo
  ? new Date(currentIgo.saleEndDate ?? currentIgoStartTime.getTime() + DEFAULT_IGO_SALE_DURATION)
  : null

export const isGoldDiggerDisabled = () => {
  if (!currentIgo) return true
  if (Date.now() > currentIgoEndTime.getTime()) return true

  return false
}
